// extracted by mini-css-extract-plugin
export var cartContainer = "_gq-4";
export var gray = "_gq-1";
export var itemContainer = "_gq-2";
export var itemDetails = "_gq-3";
export var strong = "_gq-0";